import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'
import images from '../../media'
const FondationView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <PageTitle><small>ФОНДАЦИЯ</small><br/> „ПАИСИАДА - ПРЕДАЙ НАТАТЪК!“</PageTitle>
                    <p>На неспециалистите, които разглеждат електронния сайт nauho.paissiada.com, подсказвам, че все още има десетки неиздадени преписи и преправки от българската възрожденска ръкописна „Паисиада“, а поколението учени, което е подготвено да ги публикува с високопрофесионални анализи и оценки, върви към своя професионален залез, затова академичният ни опит и всеотдайност към нашата кауза трябва да бъдат подкрепени именно СЕГА.</p>
                    <p>Ние, изследователите на българската възрожденска ръкописна „Паисиада“, вече от немалко години работим в областта на академичното Паисиезнание, като даряваме и лични средства, с цел:</p>

                    <ul>
                        <li>провеждане на дългогодишни академични проучвания на изгубения и наличен паисиеведски ръкописен фонд;</li>
                        <li>откупуване на правата за издаване на съхранените книги от българската възрожденска ръкописна „Паисиада“;</li>
                        <li>публикуване на оригиналните ръкописни книги от „Паисиада“;</li>
                        <li>превеждане на руски и английски език на академични паисиеведски изследвания, посветени на „Паисиада“, които по този начин ще станат достъпни и за чужденците, които почитат България и българското.</li>

                    </ul>
                    <div className="row">
                        <div className="col-md-8">
                            <p>Ръководени от заявеното, мотивирани да постигнем новаторски изследвания в областта на академичната възрожденистика, решени да увеличим съвременната „фен“аудитория на нашата академична и духовна кауза „ПАИСИАДА – ПРЕДАЙ НАТАТЪК!", ние, които все още милеем за Своето, учредихме и Фондация с наименованието „Паисиада – предай нататък!“ (Булстат № 177219075). Фондацията е юридическо лице с нестопанска цел за постигане на общественополезна дейност, насочена към съхраняване на ПАМЕТТА  за Паисий, неговата История и възрожденските ѝ преписвачи. Фондация „Паисиада – предай нататък!“ набира доброволни дарения от частни и колективни дарители от България и чужбина, с които ще можем да продължим вече започнатото дело.</p>
                        </div>
                        <div className="col-md-4">
                            <img data-toggle="modal" data-target="#udostoverenieModal" src={images['udostoverenie']}/>
                        </div>
                    </div>
                    <p>
                    Банковата сметка, по която могат да бъдат направени дарения, е:
                    </p>
                    <blockquote>
                        <h5 className="text-center">
                            <strong>IBAN BG65 TTBB 9400 1528 1334 33</strong><br/>
                            <strong>BIC TTBBBG22</strong><br/>
                            <strong>ТИТУЛЯР: ФОНДАЦИЯ „ПАИСИАДА – ПРЕДАЙ НАТАТЪК!"</strong>
                        </h5>
                    </blockquote>
                    <p>Имената на дарителите се вписват редом до името на Паисий Хилендарски и имената на хората разкази – така наричаме възрожденските преписвачи на „История славянобългарска“.</p>
                    <p>Ръкописните възрожденски книги от „Паисиада“, които вече сме публикували и ще публикуваме и нататък, не се продават, а се ДАРЯВАТ:</p>

                    <ul>
                        <li>на библиотеки у нас и по света;</li>
                        <li>на чуждестранни университети, в които се изучава българистика;</li>
                        <li>на чуждестранни институции, където има български представителства и български общности;</li>
                        <li>на нашите спомоществователи;</li>
                        <li>на българи, посветени в каузата да опазим българското!</li>

                    </ul>
                    <p>Искрено вярваме, че духовните послания на „Паисиада“, ще накарат и българите, и чужденците да повярват, че БЪЛГАРСКОТО Е ИЗКОННО! И Е ЗАВИНАГИ!
                    </p>
                    <p>Вижте още: <a href="http://mediacafe.bg/novini/obrazovanie/Akademichen-proekt-priobsthava-kym-tsennostite-na-bylgarskata-vyzrozhdenska-knizhovnost-literatura-i-kultura-14870">mediacafe.bg</a></p>
                </main>
            </div>
            <div className="modal fade" id="udostoverenieModal" tabindex="-1" role="dialog" aria-labelledby="udostoverenieModalTitle" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="udostoverenieModalTitle">Удостоверение</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <img src={images['udostoverenie']}/>
                    </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

FondationView.propTypes = {
    
}

export default FondationView



// WEBPACK FOOTER //
// ./src/views/Fondation/index.js